import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
import AnswerMixin, {
  ChiefComplaintAnswer,
} from '@/Mixins/BaseInformation/ChiefComplaint/Answer.mixin';
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      chiefComplaintId: null,
      disabelConfirm: false,
      addFlag: false,
      isActive: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      chiefComplaintAnswerTableHeaders: [
        { text: 'اولویت', value: 'priority', align: 'center' },
        { text: 'عنوان پاسخ', value: 'title', align: 'center' },
        { text: 'راهنما', value: 'note', align: 'center' },
        { text: 'وضعیت', value: 'isActive', align: 'right' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      answerRanks: [
        {
          id: 0,
          title: 'سفید',
        },
        {
          id: 1,
          title: 'سبز',
        },
        {
          id: 2,
          title: 'زرد',
        },
        {
          id: 3,
          title: 'قرمز',
        },
      ],
      searchCategory: null,
      searchText: this.$route?.query?.['title'],
      chiefComplaintphoneNumbers: [],
      selectedAnswer: -1,
    };
  },
  mixins: [ChiefComplaintMixin, AnswerMixin],
  methods: {
    ranksColor: function (rank) {
      switch (rank) {
        case 0:
          return 'lighten-5 grey--text';
        case 1:
          return 'lighten-2 green--text';
        case 2:
          return 'darken-2 yellow--text';
        case 3:
          return 'darken-4 red--text';
      }
    },
    // onSearch: function (evt) {
    //   this.searchText = evt?.target?.value;
    // },
    onModalValidation: function () {
      if (!this.chiefComplaintAnswer.title) {
        this.snackText = 'عنوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = true;
        return;
      }
      if (!this.chiefComplaintAnswer.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = true;
        return;
      }
      if (!this.chiefComplaintAnswer.priority?.toString()) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = true;
        return;
      }
      if (!this.chiefComplaintAnswer.rank?.toString()) {
        this.snackText = 'سطح نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.chiefComplaintAnswer.chiefComplaintId = +this.$route.params?.id;
      return true;
    },
    selectAnswer: function (id) {
      this.selectedAnswer = id;
    },
    resetSelectedAnswer: function () {
      this.selectAnswer(-1);
    },
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن پاسخ';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش پاسخ';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.showAddEditModal = true;
        this.selectAnswer(id);
        this.getAnswerHandler(id);
      }
    },
    cancelAddEditFunction: function () {
      this.isActive = false;
      this.showAddEditModal = false;
    },
    changeAnswerStatus: function (status, id) {
      const type = status ? 'makeDeactive' : 'makeActive';
      this.selectAnswer(id);
      this.confimType = type;
      this.showConfirmDialogFunction();
    },
    getPageTitle: function () {
      const chiefComplaintId = this.$route.params?.id;
      this.getChiefComplaintFunction(chiefComplaintId);
    },
    showConfirmDialogFunction: function () {
      this.disabelConfirm = false;
      if (this.confimType === 'delete') {
        this.$refs.confirm.title = 'حذف پاسخ';
        this.$refs.confirm.text = 'آیا از حذف این پاسخ اطمینان دارید؟';
      } else if (this.confimType === 'makeActive') {
        this.$refs.confirm.title = 'فعال کردن پاسخ';
        this.$refs.confirm.text = 'آیا از فعال کردن این پاسخ اطمینان دارید؟';
      } else if (this.confimType === 'makeDeactive') {
        this.$refs.confirm.title = 'غیر فعال کردن پاسخ';
        this.$refs.confirm.text = 'آیا از غیرفعال کردن این پاسخ اطمینان دارید؟؟';
      }
      this.$refs.confirm.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    resetAnswer: function () {
      this.chiefComplaintAnswer = new ChiefComplaintAnswer('', null, null, null, -1);
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType === 'delete') {
        this.deleteAnswerHandler(this.selectedAnswer);
        this.disabelConfirm = false;
      } else if (this.confimType === 'makeActive') {
        this.activeAnswerHandler(this.selectedAnswer);
        this.disabelConfirm = false;
      } else if (this.confimType === 'makeDeactive') {
        this.deactiveAnswerHandler(this.selectedAnswer);
        this.disabelConfirm = true;
      }
      this.confirmDialogCancelFunction();
    },
    confirmDialogCancelFunction: function () {
      this.$refs.confirm.showConfirmDialog = false;
      this.disabelConfirm = false;
    },
    onModalConfirm: function () {
      if (this.confimType === 'add') this.createAnswerHandler();
      else if (this.confimType === 'edit') this.editAnswerHandler();
    },
    onConfirmDelete: function (id) {
      this.selectAnswer(id);
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //delete
  },
  mounted() {
    this.getPageTitle();
  },
  computed: {
    answerPriority: function () {
      return Array.from({ length: this.allAnswersList?.length + 1 }, (_, index) => index + 1);
    },
    filterdAnswers: function () {
      const searchVal = this.$route.query?.['title'] || '';
      return [...this.transformedALlAnswersList(this.allAnswersList)].filter(({ title }) =>
        title.includes(searchVal),
      );
    },
  },
  watch: {
    searchText: function (currentVal) {
      if (currentVal) this.$router.replace({ query: { title: currentVal } });
      else {
        this.$router.replace({ query: {} });
      }
    },
  },
};
